import { Component } from 'react';
import styled, { css } from 'styled-components';

const Style = styled.button<{ isChecked: boolean }>`
  display: flex;
  margin: 0px;
  padding: 0px;
  align-items: center;
  font-style: normal;
  font-weight: normal;
  line-height: normal;
  font-size: 14px;
  letter-spacing: 0.333px;
  background-color: transparent;
  border: 0px;

  .c-check {
    position: relative;
    width: 20px;
    height: 20px;
    margin-right: 8px;
    background: #ffffff;
    border: 1px solid #e2e2e2;
    box-sizing: border-box;
    border-radius: 3px;
    flex-shrink: 0;

    ${(props: { isChecked: boolean }) =>
      props.isChecked &&
      css`
        &::after {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);

          width: 10px;
          height: 10px;
          background: #1c1c1c;
          border-radius: 3px;
        }
      `};
  }

  .c-children {
    text-align: left;
    user-select: none;
  }

  &:hover {
    cursor: pointer;
  }
`;

type Props = {
  children: any;
  isChecked: boolean;
  onChange: (isChecked: boolean) => void;
  tabIndex?: number;
};

export default class Checkbox extends Component<Props> {
  render() {
    return (
      <Style
        type="button"
        isChecked={this.props.isChecked}
        onClick={() => this.props.onChange(!this.props.isChecked)}
        tabIndex={this.props.tabIndex || 0}
      >
        <div className="c-check" />
        <div className="c-children">{this.props.children}</div>
      </Style>
    );
  }
}
